import React from 'react';
import SuperMatchListEntry from './SuperMatchListEntry';

const SuperMatchesList = ({ superMatches, requestContact }) => {
  return superMatches.map((superMatch) => {
    return <SuperMatchListEntry superMatch={superMatch} requestContact={requestContact} />;
  });
};

export default SuperMatchesList;
